<template>
  <section>
    <slot></slot>
  </section>
</template>

<script>
export default {
  name: 'xj-container'
}
</script>